export const cartTR = {
    "cart": "Sepet",
    "couponCode": "Kupon Kodu",
    "couponButton": "Kupon Kullan",
    "cartTotals": "Toplamlar",
    "completeOrder": "ÖDEME YAP",    
    "continueShopping": "ALIŞVERİŞE DEVAM ET",   
    "without": "Olmasın",
    "select": "SEÇİN",
    "selectSmall": "Seç",
    "addToCart": "Sepete eklendi",
    "cartItems": "Sepetteki Ürünler",
    "couponDiscount": "Kupon İndirimi",
    "subTotal": "Ara Toplam",
    "couponCaption": "Kuponunuz var mı?",
    "new": "YENİ",
    "sale": "İNDİRİM",
    "soldOut": "TÜKENDİ",
    "couverCaption": "Kişi Sayısı",
    "couverPlaceholder": "Sayı Girin",
    "couverError": "Lütfen kişi sayısını girip kontrol edin",

    "couverUnavailableHeader": "Kuver sorunu",

    "couverUnavailable": "Kuver sepete eklenemedi. Tekrar deneyin veya işletmeye bildirin.",
     "add": "EKLE"
}
